import {Component, ErrorInfo, ReactNode } from "react";
import { LanguageContext } from "../language/language";
import "./error-boundary-frame.less";
import ResponsiveContainer from "../components/responsive-container";
import ResponsiveContent from "../components/responsive-content";

interface Props {
  children?: ReactNode
}

interface State {
  error: Error|null
  errorInfo: ErrorInfo|null
}

export default class ErrorFrame extends Component<Props, State>  {
  constructor(props: Props) {
    super(props);

    this.state = {
      error: null,
      errorInfo: null
    }
  }

  render() {
    const { error, errorInfo } = this.state;
    const { children } = this.props;

    const url = location.pathname;

    return (
      (error && errorInfo) 
      ?
        <LanguageContext.Consumer>
          {language => (
            <ResponsiveContainer className="error-boundary-frame" centerContents={true}>
              <ResponsiveContent className="error-content">
                <h1>{language.msg.errorPage_title}</h1>
                <p>{language.msg.errorPage_content}</p>
                <ComponentError error={error} errorInfo={errorInfo} />
              </ResponsiveContent>
            </ResponsiveContainer>
          )}
        </LanguageContext.Consumer>
      :
      children
    );
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    this.setState({
      error,
      errorInfo
    })
  }
}




function ComponentError(props: { error: any, errorInfo: ErrorInfo} ) {
  const { error, errorInfo } = props;

  return <div className="component-error">
    <h2>URL</h2>
    <p>{location.pathname}</p>
    
    {(typeof error === 'object' && error.constructor === Error)
      ? <JsError error={error} />
      : (typeof error !== 'undefined' && error !== null)
        ? <StringError error={error.toString()} />
        : <NullOrUndefinedError />
    }

    <h2>Component Stack</h2>
    <pre>{errorInfo.componentStack}</pre>
  </div>
}

function JsError(props: { error: Error }) {
  const error = props.error;

  return <div className="js-error">
    <h2>JavaScript Error</h2>
    <p>{error.message}</p>
    {/* Note: stack doesn't help with webpack, especially in production! */}
    {/* {error.stack &&
    <>
      <dt>Stack Trace</dt>
      <dd>
        <pre>{error.stack}</pre>
      </dd>
    </>
    } */}
  </div>
}

function StringError(props: { error: string }) {
  const { error } = props;
  return <div className="string-error">
    <p>Error</p>
    <pre>{error.toString()}</pre>
  </div>
}

function NullOrUndefinedError() {
  return <div className="null-error">
    <p>Error</p>
    <pre>null or undefined</pre>
  </div>
}